import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-title" }
const _hoisted_2 = { class: "button-row" }

import { computed, ref, useSlots } from "vue";

interface QuestionProps {
  question?: string;
  color?: string;
  baseColor?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionDialog',
  props: {
    question: { default: "Share an “aha” moment about seasons that you experienced from using this app." },
    color: { default: "surface" },
    baseColor: {}
  },
  emits: ["dismiss", "opt-out", "finish"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable @typescript-eslint/naming-convention */


const emit = __emit;

const slots = useSlots();
const showFooter = computed(() => !!slots.footer);

const css = computed(() => ({
  "--footer-visible": showFooter.value ? "visible" : "none",
}));

const response = ref<string | null>(null);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VTextarea = _resolveComponent("VTextarea")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "question-root",
    color: __props.color,
    style: _normalizeStyle(css.value)
  }, {
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        density: "compact",
        class: "close-button",
        icon: "mdi-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dismiss', response.value)))
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.question), 1),
          _createVNode(_component_v_form, {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => { emit('finish', response.value); response.value = null; }, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  _createVNode(_component_VTextarea, {
                    modelValue: response.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((response).value = $event)),
                    class: "response-box text-body-2",
                    "max-rows": "4",
                    density: "compact",
                    width: "100%",
                    onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("span", { class: "info-text" }, " Your anonymous response will be used by the CosmicDS team to improve the educational experience. ")
              ], -1)),
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_btn, {
                      color: "#BDBDBD",
                      size: "small",
                      variant: "text",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('opt-out')))
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" Don't show this again ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      width: "fit-content",
                      color: "success"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" Submit ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["color", "style"]))
}
}

})